/* Cart icon safety net: if cart.js is late or blocked, still open the drawer instead of leaving for /cart. */
(() => {
  'use strict';
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-cart-link]');
    if (!link || event.defaultPrevented || customElements.get('cart-drawer')) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const href = link.href;
    let done = false;
    const timer = setTimeout(() => { if (!done) { done = true; window.location.assign(href); } }, 2500);
    customElements.whenDefined('cart-drawer').then(() => {
      if (done) return;
      done = true;
      clearTimeout(timer);
      document.querySelector('cart-drawer')?.open?.(link);
    });
  }, true);
})();

/* Shopify AJAX cart. Delegated events also work after filtering/section reloads. */
(() => {
  'use strict';
  const popup = document.getElementById('CroSizePopup');
  if (!popup) return;
  const root = popup.dataset.rootUrl || '/';
  const form = popup.querySelector('[data-cro-form]');
  const optionsArea = popup.querySelector('[data-cro-options]');
  const submit = popup.querySelector('[data-cro-submit]');
  const error = popup.querySelector('[data-cro-error]');
  const status = popup.querySelector('[data-cro-status]');
  let product = null, selected = [], opener = null, busy = false, requestNumber = 0;
  let oldOverflow = '';

  const showError = message => {
    error.textContent = message;
    error.hidden = !message;
  };
  const money = cents => {
    if (typeof window.formatPrice === 'function') {
      const formatted = window.formatPrice(cents, popup.dataset.moneyFormat);
      return new DOMParser().parseFromString(formatted, 'text/html').body.textContent;
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
      style: 'currency', currency: window.Shopify?.currency?.active || 'EUR'
    }).format(cents / 100);
  };
  const currentVariant = () => product?.variants.find(v =>
    v.options.every((value, index) => value === selected[index])
  );
  const canChoose = (optionIndex, value) => product.variants.some(v =>
    v.available && v.options[optionIndex] === value &&
    selected.every((choice, index) => index >= optionIndex || choice === null || v.options[index] === choice)
  );

  function updateOptions() {
    optionsArea.querySelectorAll('[data-option-index]').forEach(button => {
      const index = Number(button.dataset.optionIndex);
      button.setAttribute('aria-pressed', String(selected[index] === button.dataset.value));
      button.disabled = busy || !canChoose(index, button.dataset.value);
    });
    const variant = currentVariant();
    submit.disabled = busy || !variant?.available;
    submit.textContent = busy ? 'Ajout en cours…' : variant?.available ? 'Ajouter au panier' : 'Choisir mes options';
    status.textContent = busy ? 'Ajout au panier…' : variant?.available ? 'Votre sélection est prête.' : 'Sélectionnez vos options pour continuer.';
    popup.querySelector('[data-cro-price]').textContent = money(variant?.price ?? product.price);
    const image = popup.querySelector('[data-cro-image]');
    const src = variant?.featured_image?.src || product.featured_image;
    image.hidden = !src;
    if (src) {
      image.src = src;
      image.alt = product.title;
    }
  }

  async function openProduct(button) {
    if (busy) return;
    const token = ++requestNumber;
    opener = button;
    product = null;
    selected = [];
    optionsArea.replaceChildren();
    showError('');
    submit.disabled = true;
    submit.textContent = 'Chargement…';
    status.textContent = 'Chargement des tailles disponibles…';
    popup.querySelector('[data-cro-title]').textContent = '';
    popup.querySelector('[data-cro-price]').textContent = '';
    popup.querySelector('[data-cro-image]').hidden = true;
    const url = new URL(button.dataset.croProductUrl, window.location.origin);
    url.search = '';
    url.hash = '';
    popup.querySelector('[data-cro-details]').href = url.href;
    if (!popup.open) {
      oldOverflow = document.body.style.overflow;
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
      popup.showModal();
      document.body.style.overflow = 'hidden';
    }
    try {
      const response = await fetch(`${url.pathname}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Impossible de charger les tailles. Consultez la fiche produit.');
      const data = await response.json();
      if (token !== requestNumber || !popup.open) return;
      product = data;
      popup.querySelector('[data-cro-title]').textContent = data.title;
      popup.querySelector('#CroPopupTitle').textContent = data.options.some(o => /taille|size/i.test(o.name || o)) ? 'Choisissez votre taille' : 'Choisissez vos options';
      selected = data.options.map(() => null);
      if (data.variants.length === 1 && data.variants[0].available) {
        selected = [...data.variants[0].options];
      }
      if (data.requires_selling_plan || data.gift_card) {
        status.textContent = 'Personnalisez ce produit sur sa fiche avant de l’ajouter.';
        submit.textContent = 'Voir la fiche produit';
        return;
      }
      data.options.forEach((option, index) => {
        const values = option.values || [...new Set(data.variants.map(v => v.options[index]))];
        if (values.length === 1) {
          selected[index] = values[0];
          return;
        }
        const fieldset = document.createElement('fieldset');
        const legend = document.createElement('legend');
        legend.textContent = option.name || option;
        const list = document.createElement('div');
        list.className = 'cro-options';
        values.forEach(value => {
          const choice = document.createElement('button');
          choice.type = 'button';
          choice.className = 'cro-option';
          choice.textContent = value;
          choice.dataset.optionIndex = index;
          choice.dataset.value = value;
          list.append(choice);
        });
        fieldset.append(legend, list);
        optionsArea.append(fieldset);
      });
      updateOptions();
    } catch (err) {
      if (token !== requestNumber || !popup.open) return;
      showError(err.message);
      status.textContent = '';
    }
  }

  function closePopup() {
    if (busy) return;
    popup.close();
  }
  popup.addEventListener('close', () => {
    requestNumber++;
    document.body.style.overflow = oldOverflow;
    const drawer = document.querySelector('cart-drawer.is-visible');
    drawer?.focusOnCartDrawer?.();
    if (opener?.isConnected) opener.focus();
  });
  popup.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
  popup.querySelector('[data-cro-close]').addEventListener('click', closePopup);
  popup.addEventListener('click', event => {
    if (event.target !== popup) return;
    const box = popup.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closePopup();
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cro-product-url]');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    openProduct(button);
  });
  optionsArea.addEventListener('click', event => {
    const button = event.target.closest('[data-option-index]');
    if (!button || button.disabled || !product || busy) return;
    const index = Number(button.dataset.optionIndex);
    selected[index] = button.dataset.value;
    // Clear incompatible downstream options when an earlier option changes.
    for (let i = index + 1; i < selected.length; i++) {
      if (selected[i] !== null && !canChoose(i, selected[i])) selected[i] = null;
    }
    showError('');
    updateOptions();
  });

  form.addEventListener('submit', async event => {
    event.preventDefault();
    const variant = currentVariant();
    if (busy || !variant?.available || product.requires_selling_plan || product.gift_card) return;
    busy = true;
    showError('');
    updateOptions();
    let added = false;
    try {
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender?.() || [];
      const sectionIds = [...new Set(sections.map(s => s.section))].slice(0, 5);
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variant.id, quantity: variant.quantity_rule?.min || 1 }],
          ...(sectionIds.length ? { sections: sectionIds, sections_url: window.location.pathname } : {})
        })
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'Cet article n’a pas pu être ajouté. Veuillez réessayer.');
      added = true;
      // Missing section HTML must never cause a second add request.
      const sectionsReady = sections.some(s => typeof result.sections?.[s.section] === 'string');
      if (!drawer || !sectionsReady) {
        window.location.assign(`${root}cart`);
        return;
      }
      busy = false;
      popup.close();
      drawer.setActiveElement?.(opener);
      drawer.renderContents(result, true);
      drawer.focusOnCartDrawer?.();
      if (typeof window.updateFreeShipping === 'function') window.updateFreeShipping();
      document.dispatchEvent(new CustomEvent('cro:cart-added', { detail: { variantId: variant.id } }));
    } catch (err) {
      if (added) {
        // Cart write succeeded: go to the cart instead of inviting duplicate additions.
        window.location.assign(`${root}cart`);
      } else {
        showError(err.message || 'Connexion interrompue. Vérifiez votre panier avant de réessayer.');
      }
    } finally {
      busy = false;
      if (product) updateOptions();
    }
  });
})();
